import { render, staticRenderFns } from "./editblog.vue?vue&type=template&id=230ba4f6&scoped=true&"
import script from "./editblog.vue?vue&type=script&lang=js&"
export * from "./editblog.vue?vue&type=script&lang=js&"
import style0 from "./editblog.vue?vue&type=style&index=0&id=230ba4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ba4f6",
  null
  
)

export default component.exports